import { useQuery, QueryFunction } from 'react-query';
import { getFormAccessByUserId, getFormAccessByGroupId, FormAccess, FormAccessWithUser, getFormAccessByActiveUsers } from '../../services/apiSLTP/qhse/forms/formAccess';

type UseFormAccessByUserQueryOptions = {
    userId: string;
};

type UseFormAccessByGroupQueryOptions = {
    groupId: string;
};

type UseFormAccessActiveUsersQueryOptions = {
};

// ---- QUERY BY USER ----
const fetchFormAccessByUser: QueryFunction<FormAccess[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseFormAccessByUserQueryOptions];
    const { userId } = options;
    const response = await getFormAccessByUserId(userId);
    return response.data;
};

export const useFormAccessByUserQuery = (options: UseFormAccessByUserQueryOptions) => {
    return useQuery(['formAccessByUser', options], fetchFormAccessByUser, {
        enabled: !!options.userId,
    });
};


// ---- QUERY ACTIVE USERS ----
const fetchFormAccessByActiveUsers: QueryFunction<FormAccess[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseFormAccessActiveUsersQueryOptions];
    const {  } = options;
    const response = await getFormAccessByActiveUsers();
    return response.data;
};

export const useFormAccessByActiveUsersQuery = (options: UseFormAccessActiveUsersQueryOptions) => {
    return useQuery(['formAccessByActiveUsers', options], fetchFormAccessByActiveUsers, {
        enabled: true,
    });
};


// ---- QUERY BY GROUP ----
const fetchFormAccessByGroup: QueryFunction<FormAccessWithUser[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseFormAccessByGroupQueryOptions];
    const { groupId } = options;
    const response = await getFormAccessByGroupId(groupId);
    return response.data;
};

export const useFormAccessByGroupQuery = (options: UseFormAccessByGroupQueryOptions) => {
    return useQuery(['formAccessByGroup', options], fetchFormAccessByGroup, {
        enabled: !!options.groupId,
    });
};
